var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Dia","items":_vm.optionsDay,"error-messages":_vm.errorMessages},model:{value:(_vm.selectedDay),callback:function ($$v) {_vm.selectedDay=$$v},expression:"selectedDay"}})
}
var staticRenderFns = []

export { render, staticRenderFns }